import { render } from "./AdminTrackApprovedPayment.vue?vue&type=template&id=0cc8b5ab"
import script from "./AdminTrackApprovedPayment.vue?vue&type=script&lang=js"
export * from "./AdminTrackApprovedPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__